import type {
  BetAction,
  LoveWinsAllAction,
  LoveWinsAllState,
  ValidationResult,
} from "../types";
import { isPlayerId, legalBetMoves } from "../utils";

const ok: ValidationResult = { valid: true };

function fail(
  error: string,
  details?: Record<string, unknown>,
): ValidationResult {
  return { valid: false, error, details };
}

function validateActor(
  state: LoveWinsAllState,
  playerId: string,
): ValidationResult {
  if (!isPlayerId(playerId)) return fail("Unknown player", { playerId });
  if (state.phase === "game-over") return fail("Game is already over");
  if (state.currentPlayerId !== playerId) {
    return fail("It is not this player's turn", {
      playerId,
      currentPlayerId: state.currentPlayerId,
    });
  }
  return ok;
}

export function validateBet(
  state: LoveWinsAllState,
  action: BetAction,
): ValidationResult {
  const actor = validateActor(state, action.playerId);
  if (!actor.valid) return actor;
  if (state.phase !== "bet") {
    return fail("Betting is only allowed during the bet phase", {
      phase: state.phase,
    });
  }
  if (!legalBetMoves(state).includes(action.move)) {
    return fail("Illegal betting move", {
      move: action.move,
      legal: legalBetMoves(state),
    });
  }
  return ok;
}

export function validateAction(
  state: LoveWinsAllState,
  action: LoveWinsAllAction,
): ValidationResult {
  switch (action.type) {
    case "Bet":
      return validateBet(state, action);
  }
}
